import { render, staticRenderFns } from "./loanReview.vue?vue&type=template&id=4a7d6eaa"
import script from "./loanReview.vue?vue&type=script&lang=js"
export * from "./loanReview.vue?vue&type=script&lang=js"
import style0 from "./loanReview.vue?vue&type=style&index=0&id=4a7d6eaa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports